import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { ProjectSummary } from "@/types";

interface UseProjectParams {
  project_id: string;
  account_id: string;
  role: string;
}

export function useProject({ project_id, account_id, role }: UseProjectParams, enabled = true) {
  const query = buildParams({ account_id, role });

  return useQuery({
    queryKey: ["project", { project_id, account_id, role }],
    enabled: enabled && !!project_id,
    queryFn: () => apiFetch<ProjectSummary>(`/v1/project/${project_id}${query}`),
  });
}
